import { Component } from '@angular/core';
import { EnvironmentService } from '../services/environment.service';
import { LocalStorageService } from '../services/local-storage.service';
import { ApplicationStepType } from '../+shared/components/application-steps-generic/application-steps-generic.models';

@Component({
  selector: 'app-jurisdiction',
  templateUrl: './jurisdiction.component.html',
  styleUrls: ['./jurisdiction.component.scss'],
})
export class JurisdictionComponent {
  enableJurisdictionCheck: boolean = true;
  currentFlow = this.localStorage.getItem('original_flow');

  ApplicationStepType = ApplicationStepType;

  constructor(private environmentService: EnvironmentService, private localStorage: LocalStorageService) {
    this.enableJurisdictionCheck = this.environmentService.jurisdictionCheckEnabled;
  }
}
